import React from 'react';
import { Add } from 'components/icons';
import styles from './style.module.scss';

export const TooltipBuild = () => {
  return (
    <span className={styles.tooltip}>
      <span>build your fitting</span>
      <span>
        <Add />
      </span>
    </span>
  );
};
